import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-comment-item',
  templateUrl: './comment-item.component.html',
  styleUrls: ['./comment-item.component.scss'],
})
export class CommentItemComponent implements OnInit {
  @Input() comment = undefined;
  @Input() child = undefined;
  @Output() emitSelectComment = new EventEmitter();
  public image = '/assets/img/logo/logo-naranja-light.png';
  public url = `${environment.url}/file/`;

  constructor() { }

  ngOnInit() {}

  selectComment(id, name){
    this.emitSelectComment.emit({id, name: name || 'Anónimo'});
  }

}
